import React, { PureComponent } from 'react';

class GenderField extends PureComponent {
    render() {
        const { gender, setGender } = this.props;

        return (
            <div className="fieldwrap">
                <label htmlFor="gender">Are you male or female?</label>
                <div className="row">
                    <div className="col-sm-auto">
                        <label
                            onClick={(e) => setGender('male')}
                            className={gender == 'male' ? 'radio __active' : 'radio'}
                        >
                            <input type="radio" name="gender" /> Male
                        </label>
                    </div>
                    <div className="col-sm-auto">
                        <label
                            onClick={(e) => setGender('female')}
                            className={gender == 'female' ? 'radio __active' : 'radio'}
                        >
                            <input type="radio" name="gender" /> Female
                        </label>
                    </div>
                    <div className="col-sm-auto">
                        <label
                            onClick={(e) => setGender('Other')}
                            className={gender == 'Other' ? 'radio __active' : 'radio'}
                        >
                            <input type="radio" name="gender" /> Other
                        </label>
                    </div>
                    <div className="col-sm-auto">
                        <label
                            onClick={(e) => setGender('Prefer not to say')}
                            className={gender == 'Prefer not to say' ? 'radio __active' : 'radio'}
                        >
                            <input type="radio" name="gender" /> Prefer not to say
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

export default GenderField;



// WEBPACK FOOTER //
// ./src/Form/GenderField.js